app.service('nativeApplicationRateModal', function (_, front, modal, reportBug, orderConfig, log, nativeApp) {
	let SCROLL_THRESHOLD_VALUE; // stopień "zescrollowania" w px po którym modal może się otworzyć
	let isInit = false;
	let $self, $modal, config;
	let showNativeApplicationRateModal = false;

	function skipShowing(params) {
		console.log('Skipping showing native application rate modal with params:', params);
		showNativeApplicationRateModal = false;
		if(params?.userRequestToRateApp) {
			// pomijamy na 12 miesięcy - jeśli użytkownik ocenił aplikację - sterowane przez natywną aplikację
			nativeApp.postMessage({ type: 'ORDER_FINALIZE_APP_VOTE_REQUESTED' });
		} else {
			// pomijamy na 90 dni - jeśli użytkownik pominął prezentację modala - sterowane przez natywną aplikację
			nativeApp.postMessage({ type: 'ORDER_FINALIZE_APP_RATE_POPUP_DISMISSED' });
		}
	}

	function logAnalytics(action) {
		// event w Headless
		// { 
		// 	"id": "app_rating", 
		// 	"f03": "rate-clicked", 
		// 	"front": "headless", 
		// 	"f01": "<customerId>", 
		// 	"f02": "<visitId>", 
		// 	"currentUrl": "<url>", 
		// 	"referrer": "<referrer>", 
		// 	"customerId": "<id>", 
		// 	"login": "<login>"
		// }
		const data = {
			id: 'app_rating',
			f03: action,
			f04: document.location.href
		}
		if (typeof config?.cartStepOrderInfo !== 'undefined') {
			data.f05 = config.cartStepOrderInfo.frontUserId;
		}
		log.event(data);
		switch (action) {
			case 'layer-open':
				// otwarcia warstwy
				UA.interaction('Finalizacja zamówienia','Warstwa Oceny aplikacji','Otwarcie warstwy');
				break;
			case 'layer-closed':
				// zamknięcia warstwy
				UA.interaction('Finalizacja zamówienia','Warstwa Oceny aplikacji','Zamknięcie warstwy','Kliknięcie CTA');
				break;
			case 'rate-clicked':
				// kliknięcia przycisku "Oceń aplikację"
				UA.interaction('Finalizacja zamówienia','Warstwa Oceny aplikacji','Oceń aplikację','Kliknięcie CTA');
				break;
			case 'report-problem-clicked':
				// kliknięcia przycisku 'Zgłoś problem w aplikacji'
				UA.interaction('Finalizacja zamówienia','Warstwa Oceny aplikacji','Zgłoś problem w aplikacji','Kliknięcie CTA');
				break;
			case 'skip-clicked':
				// kliknięcia przycisku 'Pomiń'
				UA.interaction('Finalizacja zamówienia','Warstwa Oceny aplikacji','Pomiń','Kliknięcie CTA');
				break;
			default:
				break;
		}
	}

	function open() {
		if (!$modal) {
			$modal = modal.open('native-application-rate-message', {
				modifier:'remodal-full-width',
				closeOnEscape: false,
				closeOnOutsideClick: false,
			});
			modal.callbackClose($modal, function(){
				console.log('Native application rate modal closed via callback');
				logAnalytics('layer-closed');
				skipShowing();
			});
		} else {
			$modal.open();
		}
		logAnalytics('layer-open');
	}

	function openOnScroll(scrollY) {
		if(scrollY >= SCROLL_THRESHOLD_VALUE && showNativeApplicationRateModal) {
			open();
		}
	}

	function setEvents() {
		// nasłuchiwanie wiadomości od natywnej aplikacji czy zaprezentować modal oceny aplikacji
		nativeApp.setEventListener(function (eventDetail) {
			if (eventDetail?.type === 'ORDER_FINALIZE_REQUEST_TO_SHOW_APP_RATE_POPUP_AVAILABLE') {
				showNativeApplicationRateModal = eventDetail.allowed;
			}
		});

		// symulacja odpowiedzi od natywnej aplikacji (tylko do celów testowych)
		// setTimeout(() => {
		// 	showNativeApplicationRateModal = true;
		// }, 3000);

		// wysłanie wiadomości od natywnej aplikacji o gotowości do nasłuchiwania na dostępność modala oceny aplikacji
		nativeApp.postMessage({ type: 'ORDER_FINALIZE_REQUEST_TO_SHOW_APP_RATE_POPUP_READY' });

		// uruchomienie eventu podczas scrollowania strony
		_.onScroll(scrollY => openOnScroll(scrollY));

		// zdarzenia dla przycisków w ramach modala zachęcającego do oceny aplikacji
		$self.on('click', '.js-native-application-rate-vote', function() {
			logAnalytics('rate-clicked');
			skipShowing({ userRequestToRateApp: true });
			modal.close($modal);
		}).on('click', '.js-native-application-rate-report', function(){
			logAnalytics('report-problem-clicked');
			skipShowing();
			reportBug.show();
		}).on('click', '.js-native-application-rate-dismiss', function(){
			logAnalytics('skip-clicked');
			skipShowing();
			modal.close($modal);
		});
	}

	function init() {
		if (!isInit) {
			isInit = true;
			config = orderConfig.getData();
			SCROLL_THRESHOLD_VALUE = _.calculateScrollValue(config?.mobileAppRatePopupScrollThresholdPercentageValue || 10);
			$self = $('#modal-native-application-rate-message');
			if($self.length && window.mobileApp && front.page() == 'finalize') {
				setEvents();
			}
		}
	}

	return {
		init
	};
});
